import React, { useState, useEffect } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/common/Header";
import LegislatorTable from "./components/LegislatorTable/LegislatorTable";
import { getActiveSession, getAllSessions } from "./utils/sessionsOperations";
import FilterSideNav from "./components/Filters/FilterSideNav";
import LegislatorDetails from "./components/LegislatorDetails/LegislatorDetails";
import AppBuildVersion from "./components/AppBuildVersion/AppBuildVersion";

function App() {
  const [activeSession, setActiveSession] = useState(null);
  const [userSelectedSession, setUserSelectedSession] = useState(null);
  const [userSelectedLegislature, setUserSelectedLegislature] = useState(null);
  const [userSelectedStatus, setUserSelectedStatus] = useState("All");
  const [userSelectedChamber, setUserSelectedChamber] = useState([]);
  const [userSelectedParty, setUserSelectedParty] = useState([]);
  const [filterSideNavIsOpen, setFilterSideNavIsOpen] = useState(false);
  const [availableParties, setAvailableParties] = useState([]);

  useEffect(() => {
    const loadActiveSession = async () => {
      const tempActiveSession = await getActiveSession();
      const allSessions = await getAllSessions();
      const tempActiveSessionDetails = allSessions.find(
        (session) => session.id === tempActiveSession.sessionId
      );
      setActiveSession(tempActiveSessionDetails);
    };
    loadActiveSession();
  }, []);

  return (
    <>
      <Header />
      <FilterSideNav
        filterSideNavIsOpen={filterSideNavIsOpen}
        setFilterSideNavIsOpen={setFilterSideNavIsOpen}
        setActiveSession={setActiveSession}
        userSelectedSession={userSelectedSession}
        setUserSelectedSession={setUserSelectedSession}
        userSelectedLegislature={userSelectedLegislature}
        setUserSelectedLegislature={setUserSelectedLegislature}
        userSelectedStatus={userSelectedStatus}
        setUserSelectedStatus={setUserSelectedStatus}
        userSelectedChamber={userSelectedChamber}
        setUserSelectedChamber={setUserSelectedChamber}
        userSelectedParty={userSelectedParty}
        setUserSelectedParty={setUserSelectedParty}
        availableParties={availableParties}
      />
      <Router>
        <Routes>
          <Route path="/legislator/:id" element={<LegislatorDetails />} />
          <Route
            path="/"
            element={
              <LegislatorTable
                filterSideNavIsOpen={filterSideNavIsOpen}
                setFilterSideNavIsOpen={setFilterSideNavIsOpen}
                userSelectedSession={userSelectedSession}
                activeSession={activeSession}
                userSelectedLegislature={userSelectedLegislature}
                userSelectedStatus={userSelectedStatus}
                userSelectedChamber={userSelectedChamber}
                userSelectedParty={userSelectedParty}
                setAvailableParties={setAvailableParties}
              />
            }
          />
        </Routes>
      </Router>
        <AppBuildVersion></AppBuildVersion>
    </>
  );
}

export default App;
